module.exports = __webpack_public_path__ + "media/paliwa/pb_98-50c29994.png";